import { render, staticRenderFns } from "./AmlCheckWindow.vue?vue&type=template&id=580c469e&"
import script from "./AmlCheckWindow.vue?vue&type=script&lang=js&"
export * from "./AmlCheckWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports